module.exports = __webpack_public_path__ + "static/media/publication.e100e7e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/publication.svg
// module id = 295
// module chunks = 0